import { useAuthStore } from '~/stores/authStore'

/**
 * Auth plugin - initializes the auth store on app startup
 * Restores session token from localStorage so middleware can detect if
 * session restoration is needed
 */
export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()

  // Initialize auth store (restores session token from localStorage)
  // The actual user fetch is handled by the auth middleware on first navigation
  authStore.init()
})
